import { PlaceDTO } from '@/features/places/types/places.dto';
import { createAction } from '@/lib/createAction';

const placesPrefix = '[PLACES]';

export const placesFetch = createAction<`${typeof placesPrefix} FETCH`, { query: string }>(
  `${placesPrefix} FETCH`
);

export const placesFetchMore = createAction<`${typeof placesPrefix} FETCH_MORE`, undefined>(
  `${placesPrefix} FETCH_MORE`
);

export const placesSet = createAction<
  `${typeof placesPrefix} SET`,
  {
    items: PlaceDTO[];
    query: string;
    nextRangeCount: number | null;
  }
>(`${placesPrefix} SET`);

export const placesAdd = createAction<
  `${typeof placesPrefix} ADD`,
  {
    items: PlaceDTO[];
    query: string;
    nextRangeCount: number | null;
    rangeFrom: number;
    rangeTo: number;
  }
>(`${placesPrefix} ADD`);

export const placesFetchFailed = createAction<
  `${typeof placesPrefix} FETCH_FAILED`,
  { error: Error }
>(`${placesPrefix} FETCH_FAILED`);
